var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _vm.hasGaleria
        ? _c(
            "div",
            { staticClass: "grid grid-template-columns" },
            _vm._l(_vm.srcList, function(img, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("el-image", {
                    staticStyle: { width: "190px", height: "130px" },
                    attrs: { "preview-src-list": _vm.srcList, src: img }
                  })
                ],
                1
              )
            }),
            0
          )
        : _c(
            "div",
            { staticClass: "center" },
            [
              _c("app-divider", {
                attrs: { label: "Fotos", addMarginTop: false }
              }),
              _c("p", { staticClass: "mt-10" }, [
                _vm._v("Não há dados para serem exibidos.")
              ])
            ],
            1
          ),
      _vm.imovel.documentos && _vm.imovel.documentos.length > 0
        ? _c("listagem-documentos", {
            attrs: {
              documentosColetivoisReurb: _vm.documentosColetivoisReurb,
              documentos: _vm.imovel.documentos,
              protocoloCadastroOriginal: _vm.protocolo,
              ownerDocumento: "IMOVEL",
              isDetalhes: true,
              interessado: _vm.interessado,
              tempoOcupacao: _vm.imovel.tempoOcupacao,
              addMarginTop: false,
              compararDocumentos: _vm.compararGaleria.mudouDocumentosImovel,
              versaoCadastro: _vm.versaoCadastro
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-761bb553", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761bb553","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/Galeria.vue
// module id = null
// module chunks = 